import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SiteDeleteEndpointSpecification = ApiEndpointSpecification;
export const SiteDeleteEndpointSpecification: SiteDeleteEndpointSpecification = {
    url: '/api/site/:siteId/registration',
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'SiteDeleteRequestParams',
    requestBodySchemaName: 'SiteDeleteRequestBody',
    okResponseSchemaName: 'SiteDeleteOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteDelete = Helpers.makeApiRequestFn<
    Types.SiteDeleteRequestParams,
    Types.SiteDeleteRequestBody,
    Types.SiteDeleteOkResponse
>(SiteDeleteEndpointSpecification);
